export const BUILD_NUMBER = '1.0.0';
